/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NoticeCount model module.
 * @module model/NoticeCount
 * @version 1.0
 */
class NoticeCount {
    /**
     * Constructs a new <code>NoticeCount</code>.
     * @alias module:model/NoticeCount
     */
    constructor() { 
        
        NoticeCount.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NoticeCount</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NoticeCount} obj Optional instance to populate.
     * @return {module:model/NoticeCount} The populated <code>NoticeCount</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NoticeCount();

            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('unread')) {
                obj['unread'] = ApiClient.convertToType(data['unread'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * Class NoticeCount
 * @member {Number} total
 */
NoticeCount.prototype['total'] = undefined;

/**
 * Class NoticeCount
 * @member {Number} unread
 */
NoticeCount.prototype['unread'] = undefined;






export default NoticeCount;

